import React, { createContext, useState, useEffect } from "react";
import translations from "../i18n/lang";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  // Initialize with English as default - clear any previous language preference
  useEffect(() => {
    localStorage.setItem("dashboard_lang", "en");
  }, []);

  useEffect(() => {
    localStorage.setItem("dashboard_lang", lang);
  }, [lang]);

  const t = (key, vars) => {
    const val =
      translations[lang] && translations[lang][key]
        ? translations[lang][key]
        : key;
    if (!vars) return val;
    return Object.keys(vars).reduce(
      (s, k) => s.replace(new RegExp(`{${k}}`, "g"), vars[k]),
      val
    );
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
